import { render, staticRenderFns } from "./not-accepted-orders-modal.vue?vue&type=template&id=baf922a0&scoped=true&"
import script from "./not-accepted-orders-modal.js?vue&type=script&lang=js&"
export * from "./not-accepted-orders-modal.js?vue&type=script&lang=js&"
import style0 from "./not-accepted-orders-modal.scss?vue&type=style&index=0&id=baf922a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf922a0",
  null
  
)

export default component.exports